import api from '../api/api';

export default async function getStoreMenu(store, setStore) {
  return new Promise((resolve, reject) => {
    const localStore = localStorage.getItem('ant-store') ? JSON.parse(localStorage.getItem('ant-store')) : null;
    let id = store ? store.id : null;
    if (id === null && localStore) {
      setStore(localStore);
      id = localStore.id;
    }

    api
      .get(`businesses/v5/${id}`)
      .then((response) => {
        resolve(response.data.data.departments);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
